import React, { FC } from 'react';
import { hot } from 'react-hot-loader/root';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { Router, RouteComponentProps } from '@reach/router';
import { onTrack } from '@cld/analytics';
import GlobalStyles from '@cld/global-style';
import { LanguageProvider } from '@cld/intl';
import useCloudinaryFavicon from '@cld/use-cloudinary-favicon';
import { AnalyticsData } from '../hooks/useAnalytics';
import { WindowExtended } from '../types';
import { loadMessages } from '../i18n';
import { toDemo, toHome } from '../router';
import { store } from '../store';
import { theme } from '../theme';
import { LandingPage } from './LandingPage';
import { DemoPage } from './DemoPage';

const myTrackFunc = (analyticsData: AnalyticsData) => {
  (window as unknown as WindowExtended).dataLayer.push({
    event: 'event to GA',
    eventCategory: 'media library demo page',
    ...analyticsData,
  });
};

onTrack(myTrackFunc);

const App: FC = () => {
  useCloudinaryFavicon();

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <LanguageProvider loadMessages={loadMessages}>
          <Router>
            <RouterPage path={toDemo()} pageComponent={<DemoPage />} />
            <RouterPage path={toHome()} pageComponent={<LandingPage />} />
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </Provider>
  );
};

const RouterPage = (props: { pageComponent: JSX.Element } & RouteComponentProps) => props.pageComponent;

export default hot(App);
